import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { useEffect } from 'react';

function LoginPage() {
  const auth = useAuth0();
  const isAuthenticated = auth && auth.isAuthenticated;
  const loginWithRedirect = auth && auth.loginWithRedirect;

  useEffect(() => {
    const fn = async () => {
      if (!isAuthenticated) {
        await loginWithRedirect();
      }
    };
    fn();
  }, [isAuthenticated, loginWithRedirect]);

  return null;
}

export default LoginPage;
